import React, { FC, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { fetchData, formatNumber, getTranslatedValue, toasterrormsg } from '../../../reusable'
import { PageTitle } from '../../../_metronic/layout/core'
import { ToursDetailsHeader } from './ToursDetailsHeader'
import Fancybox from '../Fancybox'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { Tr } from '../../../_metronic/i18n/Tr'
import { useLang } from '../../../_metronic/i18n/Metronici18n'

const ToursOverview: FC = () => {

    const t = Tr()
    const lang = useLang()
    const navigate = useNavigate()
    const categoryId = sessionStorage.getItem('categoryId')
    useEffect(() => {
        if (categoryId != '5') {
            navigate('../dashboard/');
        }
    }, [categoryId])
    const location = useLocation();
    const toursId = (location.state as any)?.toursId || '';
    const [toursDetails, setToursDetails] = useState([]);

    const opts = {
        fullScreen: {
            autoStart: true, // Auto-start in full-screen mode
        },
        Thumbs: false,
        // Other options...
    }
    // tours Details api call
    const toursDetailsApiCall = async () => {

        var param: any = {
            toursId: toursId,
        }
        var response: any = await fetchData("public/toursDetails", param)

        if (response.status == "200") {
            setToursDetails(response.data);
        }
        else {
            toasterrormsg(response.message)
        }
    }
    useEffect(() => {
        toursDetailsApiCall()
    }, [])
    return (
        <>
            <PageTitle breadcrumbs={[]}>{t('Tours Overview')}</PageTitle>
            <ToastContainer />
            <ToursDetailsHeader />
            {toursDetails.map((tours: any, index: any) => {
                return (
                    <div className='form' key={index}>
                        {/* <!--begin::Card--> */}
                        <div className='card'>
                            {/* <!--begin::Card header--> */}
                            <div className='card-header'>
                                {/* <!--begin::Card header--> */}
                                <div className='card-title fs-3 fw-bold'>{t('Basic Details')}</div>
                                {/* <!--end::Card header--> */}
                            </div>
                            {/* <!--end::Card header--> */}
                            {/* <!--begin::Card body--> */}
                            <div className='card-body'>
                                {tours['en_name'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Tour Name (English)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div dangerouslySetInnerHTML={{ __html: tours['en_name'] }}></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tours['ru_name'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Tour Name (Russian)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div dangerouslySetInnerHTML={{ __html: tours['ru_name'] }}></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tours['uz_name'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Tour Name (Uzbek)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div dangerouslySetInnerHTML={{ __html: tours['uz_name'] }}></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tours['tourTypeDetail'] && tours['tourTypeDetail'].length > 0 && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Tour Type')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className='fw-semibold text-gray-600 mt-3'>
                                                    {/* Render the comma-separated amenity names */}
                                                    {tours['tourTypeDetail']
                                                        .filter((amenity: any) => getTranslatedValue(lang, amenity, '_name')) // Filter out amenities without a name
                                                        .map((amenity: any) => getTranslatedValue(lang, amenity, '_name')) // Extract the names
                                                        .join(', ')}
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}
                                {tours['maxPeople'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Max People')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div dangerouslySetInnerHTML={{ __html: tours['maxPeople'] }}></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tours['departureLocation'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Departure Location')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{ __html: tours['departureLocation'] }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tours['departureRegionDetail'] && tours['departureRegionDetail'].length > 0 && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Departure Region')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className='fw-semibold text-gray-600 mt-3'>
                                                    {/* Render the comma-separated amenity names */}
                                                    {tours['departureRegionDetail']
                                                        .filter((amenity: any) => getTranslatedValue(lang, amenity, '_name')) // Filter out amenities without a name
                                                        .map((amenity: any) => getTranslatedValue(lang, amenity, '_name')) // Extract the names
                                                        .join(', ')}
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}

                                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                                    <div className='fs-3 fw-bold mb-5 '>{t('Tour Details')}</div>
                                </div>
                                {tours['en_highlight'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Highlight (English)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div dangerouslySetInnerHTML={{ __html: tours['en_highlight'] }}></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tours['ru_highlight'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Highlight (Russian)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div dangerouslySetInnerHTML={{ __html: tours['ru_highlight'] }}></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tours['uz_highlight'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Highlight (Uzbek)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div dangerouslySetInnerHTML={{ __html: tours['uz_highlight'] }}></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tours['en_itinarary'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Itinarary (English)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div dangerouslySetInnerHTML={{ __html: tours['en_itinarary'] }}></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tours['ru_itinarary'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Itinarary (Russian)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div dangerouslySetInnerHTML={{ __html: tours['ru_itinarary'] }}></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tours['uz_itinarary'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Itinarary (Uzbek)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div dangerouslySetInnerHTML={{ __html: tours['uz_itinarary'] }}></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}

                                {tours['en_whatToExpect'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('What To Expect? (English)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div dangerouslySetInnerHTML={{ __html: tours['en_whatToExpect'] }}></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tours['ru_whatToExpect'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('What To Expect? (Russian)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div dangerouslySetInnerHTML={{ __html: tours['ru_whatToExpect'] }}></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tours['uz_whatToExpect'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('What To Expect? (Uzbek)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div dangerouslySetInnerHTML={{ __html: tours['uz_whatToExpect'] }}></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tours['meetingPoints'] && tours['meetingPoints'].length > 0 && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Meeting Point (English)')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className='fw-semibold text-gray-600 mt-3'>
                                                    {/* Render the comma-separated point names */}
                                                    {tours['meetingPoints']
                                                        .filter((point: any) => point['en_name']) // Filter out amenities without a name
                                                        .map((point: any) => point['en_name']) // Extract the names
                                                        .join(', ')}
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}
                                {tours['meetingPoints'] && tours['meetingPoints'].length > 0 && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Meeting Point (Russian)')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className='fw-semibold text-gray-600 mt-3'>
                                                    {/* Render the comma-separated point names */}
                                                    {tours['meetingPoints']
                                                        .filter((point: any) => point['ru_name']) // Filter out amenities without a name
                                                        .map((point: any) => point['ru_name']) // Extract the names
                                                        .join(', ')}
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}
                                {tours['meetingPoints'] && tours['meetingPoints'].length > 0 && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Meeting Point (Uzbek)')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className='fw-semibold text-gray-600 mt-3'>
                                                    {/* Render the comma-separated point names */}
                                                    {tours['meetingPoints']
                                                        .filter((point: any) => point['uz_name']) // Filter out amenities without a name
                                                        .map((point: any) => point['uz_name']) // Extract the names
                                                        .join(', ')}
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}
                                {tours['en_meetingPoint'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Meeting Points (English)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div dangerouslySetInnerHTML={{ __html: tours['en_meetingPoint'] }}></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tours['ru_meetingPoint'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Meeting Points (Russian)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div dangerouslySetInnerHTML={{ __html: tours['ru_meetingPoint'] }}></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tours['uz_meetingPoint'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Meeting Points (Uzbek)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div dangerouslySetInnerHTML={{ __html: tours['uz_meetingPoint'] }}></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}

                                {tours['en_activityEssential'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Activity Essential (English)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: tours['en_activityEssential'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tours['ru_activityEssential'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Activity Essential (Russian)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: tours['ru_activityEssential'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tours['uz_activityEssential'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Activity Essential (Uzbek)')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: tours['uz_activityEssential'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                                    <div className='fs-3 fw-bold mb-5 '>{t('Facility & Services')}</div>
                                </div>

                                {tours['services'] && tours['services'].length > 0 && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Services')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className='fw-semibold text-gray-600 mt-3'>
                                                    {/* Render the comma-separated amenity names */}
                                                    {tours['services']
                                                        .filter((amenity: any) => getTranslatedValue(lang, amenity, '_name')) // Filter out amenities without a name
                                                        .map((amenity: any) => getTranslatedValue(lang, amenity, '_name')) // Extract the names
                                                        .join(', ')}
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}
                                {tours['serviceLanguageDetail'] && tours['serviceLanguageDetail'].length > 0 && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Service Language Type')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className='fw-semibold text-gray-600 mt-3'>
                                                    {/* Render the comma-separated amenity names */}
                                                    {tours['serviceLanguageDetail']
                                                        .filter((amenity: any) => getTranslatedValue(lang, amenity, '_name')) // Filter out amenities without a name
                                                        .map((amenity: any) => getTranslatedValue(lang, amenity, '_name')) // Extract the names
                                                        .join(', ')}
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}

                                {tours['notIncluded'] && tours['notIncluded'].length > 0 && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Not Included')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className='fw-semibold text-gray-600 mt-3'>
                                                    {/* Render the comma-separated amenity names */}
                                                    {tours['notIncluded']
                                                        .filter((amenity: any) => getTranslatedValue(lang, amenity, '_name')) // Filter out amenities without a name
                                                        .map((amenity: any) => getTranslatedValue(lang, amenity, '_name')) // Extract the names
                                                        .join(', ')}
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}
                                {tours['included'] && tours['included'].length > 0 && (
                                    <div className='row mb-8'>
                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-3'>
                                            <div className='fs-6 fw-bold mt-2 mb-3'>{t('Included')}</div>
                                        </div>
                                        {/* <!--end::Col--> */}

                                        {/* <!--begin::Col--> */}
                                        <div className='col-xl-9'>
                                            {/* <!--begin::Progress--> */}
                                            <div className='d-flex flex-column'>
                                                <div className='fw-semibold text-gray-600 mt-3'>
                                                    {/* Render the comma-separated amenity names */}
                                                    {tours['included']
                                                        .filter((amenity: any) => getTranslatedValue(lang, amenity, '_name')) // Filter out amenities without a name
                                                        .map((amenity: any) => getTranslatedValue(lang, amenity, '_name')) // Extract the names
                                                        .join(', ')}
                                                </div>
                                            </div>
                                            {/* <!--end::Progress--> */}
                                        </div>
                                        {/* <!--end::Col--> */}
                                    </div>
                                )}

                                <div className='col-xl-3 border-bottom border-light border-2 w-100 mb-5 mt-5'>
                                    <div className='fs-3 fw-bold mb-5 '>{t('Pricing & Availability')}</div>
                                </div>
                                {tours['price'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Tour Price')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        {formatNumber(parseFloat(tours['price']))}{' '}
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tours['durationDay'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Tour Package Duration Day')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: tours['durationDay'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tours['durationHour'] ? (
                                    <>
                                        {/* <!--begin::Row--> */}
                                        <div className='row mb-8'>
                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Tour Package Duration Hour')}</div>
                                            </div>
                                            {/* <!--end::Col--> */}

                                            {/* <!--begin::Col--> */}
                                            <div className='col-xl-9'>
                                                {/* <!--begin::Progress--> */}
                                                <div className='d-flex flex-column'>
                                                    <div className=' fw-semibold text-gray-600 mt-3'>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: tours['durationHour'],
                                                            }}
                                                        ></div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Progress--> */}
                                            </div>
                                            {/* <!--end::Col--> */}
                                        </div>
                                        {/* <!--end::Row--> */}
                                    </>
                                ) : (
                                    ''
                                )}
                                {tours['isYear'] == 1 ? (
                                    <>
                                        <div className='row mb-8'>
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Availability')}</div>
                                            </div>
                                            <div className='col-xl-9'>
                                                <div className='d-flex flex-column'>
                                                    <div className='fw-semibold text-gray-600 mt-3'>{t('All year around')}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className='row mb-8'>
                                            <div className='col-xl-3'>
                                                <div className='fs-6 fw-bold mt-2 mb-3'>{t('Availability')}</div>
                                            </div>
                                            <div className='col-xl-9'>
                                                <div className='d-flex flex-column'>
                                                    <div className='fw-semibold text-gray-600 mt-3 d-flex'>
                                                        {new Date(tours['fromAvailableDate']).toLocaleDateString('en-GB', {
                                                            day: '2-digit',
                                                            month: 'long',
                                                            year: 'numeric',
                                                        })}{' '}
                                                        <div className='date-separator'></div>
                                                        to{' '}
                                                        {new Date(tours['toAvailableDate']).toLocaleDateString('en-GB', {
                                                            day: '2-digit',
                                                            month: 'long',
                                                            year: 'numeric',
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                                {tours['images'].length != 0 ? (
                                    <div className='col-xl-12'>
                                        {/* <!--begin::Engage widget 7--> */}
                                        <div className='card card-flush h-xl-100'>
                                            <div className='pt-7'>
                                                <div className='row align-items-end h-100 gx-5 gx-xl-10'>
                                                    {tours['images'].map((images: any, index: any) => {
                                                        return (
                                                            <>
                                                                <Fancybox options={opts}>
                                                                    {/* <!--begin::Col--> */}
                                                                    <div className='col-md-4 mb-11 mb-md-0' key={index}>
                                                                        {/* <!--begin::Overlay--> */}
                                                                        <a
                                                                            data-fancybox='gallery'
                                                                            className='d-block overlay'
                                                                            data-fslightbox='lightbox-hot-sales'
                                                                            href={images['mediaPath']}
                                                                        >
                                                                            <div
                                                                                className='overlay-wrapper bgi-position-center bgi-no-repeat bgi-size-cover h-200px card-rounded mb-3'
                                                                                style={{
                                                                                    height: '266px',
                                                                                    backgroundImage: `url('${images['mediaPath']}')`,
                                                                                }}
                                                                            ></div>
                                                                            {/* <!--end::Image--> */}

                                                                            {/* <!--begin::Action--> */}
                                                                            <div className='overlay-layer card-rounded bg-dark bg-opacity-25'>
                                                                                <i className='ki-outline ki-eye fs-3x text-white'></i>{' '}
                                                                            </div>
                                                                            {/* <!--end::Action-->       */}
                                                                        </a>
                                                                        {/* <!--end::Overlay-->          */}
                                                                    </div>
                                                                    {/* <!--end::Col-->      */}
                                                                </Fancybox>
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                                {/* <!--end::Row--> */}
                                            </div>
                                            {/* <!--end::Card body--> */}
                                        </div>
                                        {/* <!--end::Engage widget 7--> */}
                                    </div>
                                ) : (
                                    <div className='col-xl-12'>
                                        {/* <!--begin::Engage widget 1--> */}
                                        <div className='card h-md-100' dir='ltr'>
                                            {/* <!--begin::Body--> */}
                                            <div className='card-body d-flex flex-column flex-center'>
                                                {/* <!--begin::Heading--> */}
                                                <div className='mb-2'>
                                                    {/* <!--begin::Illustration--> */}
                                                    <div className='py-10 text-center'>
                                                        <img
                                                            src={toAbsoluteUrl('/media/svg/illustrations/easy/2.svg')}
                                                            className='theme-light-show h-125px'
                                                            alt=''
                                                        />
                                                        <img
                                                            src={toAbsoluteUrl('/media/svg/illustrations/easy/2-dark.svg')}
                                                            className='theme-dark-show h-125px'
                                                            alt=''
                                                        />
                                                    </div>
                                                    {/* <!--end::Illustration--> */}
                                                </div>
                                                {/* <!--end::Heading--> */}
                                            </div>
                                            {/* <!--end::Body--> */}
                                        </div>
                                        {/* <!--end::Engage widget 1--> */}
                                    </div>
                                )}
                            </div>

                        </div>
                        {/* <!--end::Card--> */}
                    </div>
                )
            })}
        </>
    )
}

export { ToursOverview }